let productsFilter = {};

(function (productsFilterApp) {
    const filterModel = {
        CurrentPage: 1,
        PageSize: 12,
        SearchTerm: "",
        Format: "",
        PurchaseType: "",
        Tags: "",
        Collections: "",
        Teachers: "",
        Languages: "",
        Title: "",
        Resources: "all",
        Vendor: ""
    }

    let fromPopState = false;
    let blockPopstateEvent = true;
    const browserSupportsHistoryApi = window.history && 'pushState' in window.history;
    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            const currentPath = window.location.pathname;
            let query = "?";
            const queryArray = [];
            if (filterModel.CurrentPage && filterModel.CurrentPage > 1) {
                queryArray.push("page=" + filterModel.CurrentPage);
            }
            if (filterModel.Title) {
                queryArray.push("title=" + filterModel.Title);
            }
            if (filterModel.Tags) {
                queryArray.push("tags=" + filterModel.Tags);
            }
            if (filterModel.Teachers) {
                queryArray.push("teachers=" + filterModel.Teachers);
            }
            if (filterModel.Collections) {
                queryArray.push("collections=" + filterModel.Collections);
            }
            if (filterModel.PurchaseType) {
                queryArray.push("purchase=" + filterModel.PurchaseType);
            }
            if (filterModel.Languages) {
                queryArray.push("languages=" + filterModel.Languages);
            }
            if (filterModel.Format) {
                queryArray.push("format=" + filterModel.Format);
            }
            if (filterModel.Resources) {
                queryArray.push("resources=" + filterModel.Resources);
            }
            if (filterModel.SearchTerm) {
                queryArray.push("search=" + filterModel.SearchTerm);
            }
            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.CurrentPage = 1;
        filterModel.SearchTerm = "";
        filterModel.Format = "";
        filterModel.PurchaseType = "";
        filterModel.Tags = "";
        filterModel.Collections = "";
        filterModel.Teachers = "";
        filterModel.Languages = "";
        filterModel.Title = "";
        filterModel.Resources = "";
        filterModel.Vendor = "";

        if (window.location.search.length > 1) {
            for (let aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                const key = decodeURIComponent(aItKey[0]).toLowerCase();
                const val = decodeURIComponent(aItKey[1]);

                if (key === "page") {
                    filterModel.CurrentPage = val;
                } else if (key === "title") {
                    filterModel.Title = val;
                } else if (key === "tags") {
                    filterModel.Tags = val;
                } else if (key === "teachers") {
                    filterModel.Teachers = val;
                } else if (key === "collections") {
                    filterModel.Collections = val;
                } else if (key === "purchase") {
                    filterModel.PurchaseType = val;
                } else if (key === "format") {
                    filterModel.Format = val;
                } else if (key === "languages") {
                    filterModel.Languages = val;
                } else if (key === "resources") {
                    filterModel.Resources = val;
                } else if (key === "search") {
                    filterModel.SearchTerm = val;
                }
            }
        }

        setFilterInputs();
        productsFilter.GetSearchResult();
    }

    function setFilterInputs() {
        setFilterInput(filterModel.Tags, "js-category-filter");
        setFilterInput(filterModel.Format, "js-format-filter");
        setFilterInput(filterModel.Teachers, "js-teacher-filter");
        setFilterInput(filterModel.Collections, "js-collection-filter");
        setFilterInput(filterModel.PurchaseType, "js-purchase-type-filter");
        setFilterInput(filterModel.Languages, "js-language-filter");
        setFilterInput(filterModel.Resources, "js-resource-filter", "radio");

        $(".js-search-field").val(filterModel.SearchTerm);
    }

    function setFilterInput(filter, selector, inputType = "checkbox") {
        $(`.${selector} input[type='${inputType}']`).each(function (i, tagItem) {
            const tag = $(tagItem).data("tags");
            $(tagItem).prop("checked", filter.includes(tag));
        });
    }

    function setFilterModel(isResetPage = false) {
        setFilter("format", "js-format-filter");
        setFilter("category", "js-category-filter");
        setFilter("collection", "js-collection-filter");
        setFilter("teachers", "js-teacher-filter");
        setFilter("purchase", "js-purchase-type-filter");
        setFilter("language", "js-language-filter");

        const resourceTags = $(".js-resource-filter input[type='radio']:checked").data("tags");
        filterModel.Resources = "";
        if (resourceTags && resourceTags.length > 0) {
            filterModel.Resources = resourceTags;
        }

        if (isResetPage) {
            filterModel.CurrentPage = 0;
        }

        filterModel.SearchTerm = $(".js-search-field").val();
    }

    function setFilter(filterToSet, selector) {

        const selected = [];
        $(`.shop-filters.${selector} input[type='checkbox']:checked`).each(function (i, tagItem) {
            const tag = $(tagItem).data("tags");
            if (tag && tag.trim() !== "") {
                selected.push(tag);
            }
        });

        switch (filterToSet) {
        case "format":
            filterModel.Format = selected.join(",");
            break;
        case "category":
            filterModel.Tags = selected.join(",");
            break;
        case "collection":
            filterModel.Collections = selected.join(",");
            break;
        case "teachers":
            filterModel.Teachers = selected.join(",");
            break;
        case "purchase":
            filterModel.PurchaseType = selected.join(",");
            break;
        case "language":
            filterModel.Languages = selected.join(",");
            break;
        default:
            // code block
        }
    }

    productsFilter.GetSearchResult = function () {
        filterModel.CurrentPage++;
        $.ajax({
            url: "/umbraco/surface/ProductsSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-products-filter-results .js-products-list-wrapper").html(data);
                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    $(document).ready(function () {

        //Get url params on load
        const urlParams = new URLSearchParams(window.location.search);

        //check if querystring params exist on load/reload
        if (urlParams.get('page'))
            filterModel.CurrentPage = urlParams.get('page');

        if (urlParams.get('title'))
            filterModel.Title = urlParams.get('title');

        if (urlParams.get('tags'))
            filterModel.Tags = urlParams.get('tags');

        if (urlParams.get('collections'))
            filterModel.Collections = urlParams.get('collections');

        if (urlParams.get('teachers'))
            filterModel.Teachers = urlParams.get('teachers');

        if (urlParams.get('purchase'))
            filterModel.PurchaseType = urlParams.get('purchase');

        if (urlParams.get('format'))
            filterModel.Format = urlParams.get('format');

        if (urlParams.get('languages'))
            filterModel.Languages = urlParams.get('languages');

        if (urlParams.get('resources'))
            filterModel.Resources = urlParams.get('resources');

        if (urlParams.get('search'))
            filterModel.SearchTerm = urlParams.get('search');

        setFilterInputs();

        $(document).on("click", ".js-products-filter-results .js-search-button", function (e) {
            e.preventDefault();
            setFilterModel(true);
            productsFilter.GetSearchResult();
        });

        $(document).on("click", ".js-clear-button", function (e) {
            e.preventDefault();
            filterModel.CurrentPage = 0;
            filterModel.SearchTerm = "";
            filterModel.Format = "";
            filterModel.PurchaseType = "";
            filterModel.Tags = "";
            filterModel.Collections = "";
            filterModel.Teachers = "";
            filterModel.Languages = "";
            filterModel.Title = "";
            filterModel.Resources = "all";
            filterModel.Vendor = "";
            $(".js-search-field").val("");
            $('input:checkbox').prop('checked', false)
            productsFilter.GetSearchResult();
        });

        $(document).on("click", ".js-products-filter-results .js-loadmore-button", function (e) {
            e.preventDefault();
            setFilterModel();
            productsFilter.GetSearchResult();
        });

        $(document).on("click", ".shop-resource-filters .shop-resource-filters__item label", function (e) {
            e.preventDefault();
            $(this).closest(".shop-resource-filters__item").find("input[type='radio']").trigger('click');
            setFilterModel(true);
            productsFilter.GetSearchResult();

        });

        $(document).on("submit", "#prduct-search-form", function (e) {
            e.preventDefault();
            setFilterModel(true);
            productsFilter.GetSearchResult();

        });
    });

})(productsFilter);
